import PaymentQuestions from '@/content/faqs/answers/signup/payment.json';

export default class FaqPayment {
    /**
     * Get the accounts questions.
     *
     * @return {Promise}
     */
    handle() {
        return new Promise((resolve) => resolve(PaymentQuestions.items));
    };
}
